export enum API_STATUS {
  OK = 'OK',
  LOADING = 'LOADING',
  ERROR = 'ERROR',
  INITIAL = 'INITIAL',
}
